<div class="wrapper">
  <div class="content">
    <div>
      <svg
        width="52"
        height="52"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="26" cy="26" r="25" stroke="#B8301C" stroke-width="2" />
        <path
          d="M27 9C27 8.44772 26.5523 8 26 8C25.4477 8 25 8.44772 25 9L27 9ZM25 9L25 37L27 37L27 9L25 9Z"
          fill="#B8301C"
        />
        <rect x="25" y="41" width="2" height="2" fill="#B8301C" />
      </svg>
    </div>
    <div class="message">An error has occurred. Please try again.</div>
    <button class="secondary-button" (click)="reloadApp()">BACK</button>
  </div>
</div>
